import apiService from '../../../services/api'
import { openExternalPaymentLink } from '../utils/openExternalPaymentLink'

/**
 * TJS1 (Таджикистан) API
 * Оплата через Noros в таджикских сомони
 * Точная копия Noros UZS, но валюта — TJS (целые числа)
 */

export const fetchTjsConfig = async () => {
  try {
    const response = await apiService.makeRequest('/api/tjs1/')

    if (response.tjs) {
      return { ...response.tjs, promo: response.promo || null }
    }

    throw new Error('Invalid response format: tjs config not found')
  } catch (error) {
    console.error('Error fetching TJS config:', error)
    throw error
  }
}

export const fetchTjsPackages = async () => {
  try {
    const response = await apiService.makeRequest('/api/topup/')

    if (response.topup && Array.isArray(response.topup)) {
      return response.topup.filter((pkg) => pkg.tjs1 !== undefined)
    }

    throw new Error('Invalid response format: topup array not found')
  } catch (error) {
    console.error('Error fetching TJS packages:', error)
    throw error
  }
}

const normalizeTjsCreateError = (response) => {
  if (!response?.error) return null

  if (response.error === 'error sum') return 'INVALID_AMOUNT'
  if (response.error === 'error backend') return 'BACKEND_ERROR'
  if (response.error === 'error limit') return 'LIMIT_ORDER'

  return response.error
}

/**
 * Создать платеж по сумме в сомони
 * @param {number} tjs - Сумма в TJS (целое число > 0)
 */
export const createPaymentByTjs = async (tjs) => {
  try {
    const response = await apiService.makeRequest('/api/tjs1/', {
      method: 'POST',
      body: JSON.stringify({ tjs })
    })

    const normalizedError = normalizeTjsCreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating TJS payment by tjs:', error)
    throw error
  }
}

/**
 * Создать платеж по сумме в кристаллах
 * @param {number} crystals - Количество кристаллов (целое число > 0)
 */
export const createPaymentByCrystals = async (crystals) => {
  try {
    const response = await apiService.makeRequest('/api/tjs1/', {
      method: 'POST',
      body: JSON.stringify({ crystal: crystals })
    })

    const normalizedError = normalizeTjsCreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating TJS payment by crystals:', error)
    throw error
  }
}

export const openTjsPayment = (paymentLink, onRedirect, paymentWindow = null) => {
  openExternalPaymentLink(paymentLink, onRedirect, 'TJS', paymentWindow)
}

export default {
  fetchTjsConfig,
  fetchTjsPackages,
  createPaymentByTjs,
  createPaymentByCrystals,
  openTjsPayment
}
